/**
 * Кто сейчас говорит — по identity участника, а не по объекту плитки.
 * Плитка в React-стейте пересоздаётся копией при каждом mute/unmute, и колбэк,
 * записанный в один экземпляр, переставал получать обновления: рамка «говорит»
 * застывала в последнем значении.
 */
export function createActiveSpeakerRegistry() {
    let active = new Set();
    const listeners = new Map();
    return {
        update(identities) {
            const previous = active;
            active = new Set(identities);
            listeners.forEach((identityListeners, identity) => {
                const isActive = active.has(identity);
                if (isActive === previous.has(identity))
                    return;
                identityListeners.forEach((listener) => listener(isActive));
            });
        },
        subscribe(identity, listener) {
            const identityListeners = listeners.get(identity) ?? new Set();
            identityListeners.add(listener);
            listeners.set(identity, identityListeners);
            listener(active.has(identity));
            return () => {
                identityListeners.delete(listener);
                if (identityListeners.size === 0 && listeners.get(identity) === identityListeners) {
                    listeners.delete(identity);
                }
            };
        },
    };
}
